<template>
	<div class="superMarket" :class="{'isiOSX':isiOSX}">
		<van-nav-bar v-if="isApp" title="申请加盟商" :fixed="true"/>
    	<img v-if="isApp" @click="goBack()" class="reback" src="../../assets/myInvest/reback.png">
    	<img v-if="isApp" @click="applyMerchantShare()" class="share" src="../../assets/common/xb_title_share.png">
		<van-row>
			<van-col span="24" class="banner" :style="paddT">
         		<img class="ban" src="../../assets/advDetail/market/banner.png" />
         		<div class="word">
         			<div class="box">
         				<p class="title"><img class="left" src="../../assets/advDetail/market/zs1.png" alt="" /><img class="middle" src="../../assets/advDetail/market/fk.png" alt="" /><img class="right" src="../../assets/advDetail/market/zs1.png" alt="" /></p>
         				<p class="adv">零售不好做？</p>
         				<p class="adv">加盟销巴生活超市，让实体零售火起来</p>
         			</div>
         		</div>
         		<img class="corses" src="../../assets/advDetail/market/corses.png" />
			</van-col>
			<van-col span="24" class="Profit">
				<div class="box">
        			<p class="title"><img class="corses" src="../../assets/advDetail/market/wdsy.png" /></p>
        			<div class="profit1">
        				<p><span class="tit">日常经营收益</span></p>
        				<p class="desc">使用消费商模式锁定客户，增加客户粘性，从而提高日常经营收益。</p>
        				<img class="corses" src="../../assets/advDetail/market/date.png" />
        			</div>
        			<div class="profit2">
        				<p><span class="tit">房屋装修收益</span></p>
        				<p class="desc">提供房租装修积分补贴，减轻运营成本。</p>
        				<img class="corses" src="../../assets/advDetail/market/fz.png" />
        			</div>
        			<div class="profit1 profit3">
        				<p><span class="tit">积分收益</span></p>
        				<p class="desc">日常累计积分以每日<span>0.03%</span>或<span>0.05%</span>的速度转化。</p>
        				<img class="corses" src="../../assets/advDetail/market/gift.png" />
        			</div>
        			<div class="profit2 profit4">
        				<p><span class="tit">采购收益</span></p>
        				<p class="desc">通过销巴供应链采购商品，可享受每日<span>0.04%</span>的积分增值。</p>
        				<img class="corses" src="../../assets/advDetail/market/cg.png" />
        			</div>
        			<div class="profit1 profit5">
        				<p><span class="tit">跨界收益</span></p>
        				<p class="desc">通过高效分享，可享受消费额<span>0.2%</span>或<span>0.3%</span>的佣金。</p>
        				<img class="corses" src="../../assets/advDetail/market/kj.png" />
        			</div>
        		</div>
			</van-col>
			<van-col span="24" class="advantage">
				<div class="box">
         			<p class="title"><img class="left" src="../../assets/advDetail/market/zs2_l.png" alt="" /><img class="middle" src="../../assets/advDetail/market/ys.png" alt="" /><img class="right" src="../../assets/advDetail/market/zs2_r.png" alt="" /></p>
         			<div class="super">
         				<p class="tit">
         					<img src="../../assets/advDetail/market/unify.png" alt="" />
         					<span class="name">统一管理</span>
         					<span class="border"></span>
         				</p>
         				<p class="con">由总部统一进行门店规划及经营管理推广，提高门店曝光率。</p>
         			</div>
         			<div class="super super2">
         				<p class="tit">
         					<img src="../../assets/advDetail/market/zjnd.png" alt="" />
         					<span class="name">增加粘度</span>
         					<span class="border"></span>
         				</p>
         				<p class="con">消费增值模式,使会员与门店及销巴生活APP形成无法脱离的关系，需求由“我需要你才来买“，转变成“你需要我，你不得不来买”。</p>
         			</div>
         			<div class="super">
         				<p class="tit">
         					<img src="../../assets/advDetail/market/updata.png" alt="" />
         					<span class="name">提高体验</span>
         					<span class="border"></span>
         				</p>
         				<p class="con">会员不仅在门店可选购优质商品，还能在线上随时随地畅快购物，打破时间和空间的限制。</p>
         			</div>
         			<div class="super super4">
         				<p class="tit">
         					<img src="../../assets/advDetail/market/increment.png" alt="" />
         					<span class="name">消费增值</span>
         					<span class="border"></span>
         				</p>
         				<p class="con">让消费者用消费的钱享受增值服务，用销巴模式提高门店与周边门店的竞争力。</p>
         			</div>
         			<div class="super super5">
         				<p class="tit">
         					<img src="../../assets/advDetail/market/yyzc.png" alt="" />
         					<span class="name">运营支持</span>
         					<span class="border"></span>
         				</p>
         				<p class="con">销巴集团资深运营团队支持，免费提供商业推广及品牌营销与电商运营指导。</p>
         			</div>
         			<div class="super super6">
         				<p class="tit">
         					<img src="../../assets/advDetail/market/jf.png" alt="" />
         					<span class="name">积分增值</span>
         					<span class="border"></span>
         				</p>
         				<p class="con">平台服务费以等额积分的形式永久增值服务。</p>
         			</div>
         		</div>
			</van-col>
			<van-col span="24" class="require">
				<p class="title"><img class="left" src="../../assets/advDetail/market/zs3_l.png" alt="" /><img class="middle" src="../../assets/advDetail/market/require.png" alt="" /><img class="right" src="../../assets/advDetail/market/zs3_r.png" alt="" /></p>
         		<div class="req">
         			<div class="box">
         				<div class="con">
         					<p class="top">门店要求</p>
         					<p class="middle">视实际情况而定，</p>
         					<p class="bottom">原则上不低于100m²</p>
         				</div>
         			</div>
         		</div>
         		<div class="req">
         			<div class="box">
         				<div class="con">
         					<p class="top">采购要求</p>
         					<p class="middle">自主采购，</p>
         					<p class="bottom">或选择销巴供应链</p>
         				</div>
         			</div>
         		</div>
         		<div class="req ">
         			<div class="box">
         				<div class="con" :style="{'height': Height}">
         					<p class="top">商户服务费</p>
         					<p class="middle">营业额的<span>15%，</span></p>
         					<p class="bottom">享永久性积分增值补贴</p>
         				</div>
         			</div>
         		</div>
         		<div class="req ">
         			<div class="box" ref="req2">
         				<div class="con">
         					<p class="top">运营管理费</p>
         					<p class="middle"><span>≤150㎡</span>，统一收取1.5万元人民币；<span>>150㎡</span>，收取100元人民币/㎡</p>
         					<!--<p class="bottom"></p>-->
         				</div>
         			</div>
         		</div>
         		<p class="clear"></p>
			</van-col>
			<van-col span="24" class="contract">
				<div class="box">
         			<p class="title"><img src="../../assets/advDetail/market/logo.png"/></p>
         			<p class="con">销巴生活超市在分享经济背景下，以刚需消费为基本原则，坚持利他为指导思想，通过积分体系保障，对多场景实体零售进行深度融合，从而构建“销巴生活超市”新零售模式。</p>
                	<p class="tit"><img src="../../assets/advDetail/market/contract.png"/></p>
                	<p class="tip">销巴生活超市招商负责人</p>
                	<p class="phone">132-8158-7999（任总/其他地区）</p>
         			<p class="phone">134-5682-0222（李总/江浙沪）</p>
         		</div>
			</van-col>
			<van-col span="24" class="footer">
				<span class="btn" @click="consultation()">点击申请加盟商</span>
			</van-col>
			
		</van-row>
	</div>
</template>

<script>
export default {
  data() {
    return {
    	isApp: true,
      	isiOSX: false,
    	Height: '92px',
    	paddT: {paddingTop: '68px'} //app内
    };
  },
  created(){
  	this.isiOSX = this.isIphoneX();
  	if(this.$route.query.from) {//app外
  		this.isApp = false;
  		this.paddT = {paddingTop: '0'}
  	}else {
  		if(this.isiOSX) {//app内齐刘海
  			this.paddT = {paddingTop: '88px'}
  		}
  	}
  },
  methods: {
  	goBack() {
  		this.params('', '', 'goBack');
  	},
    consultation() {
	    this.$router.push({
          path: "/advDetail/applyFor",
          query: {
            type: this.$route.query.type
          }
        });
	},
    applyMerchantShare() {
    	this.params('', '', 'applyMerchantShare');
    }
  },
  mounted() {
	this.Height = this.$refs.req2.offsetHeight - 35 + 'px';
  }
};
</script>

<style lang="less">
.superMarket {
	background: #C11814;
	min-height: 100%;
	.van-nav-bar {
	    height: 44px;
	    line-height: 44px;
	    padding-top: 24px;
	    box-shadow: 0 1px 0 #eee;
	    .van-nav-bar__title {
	      color: #333;
	      font-size: 17px;
	      font-weight: 700;
	    }
	}
	.reback {
	    width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    left: 0;
	    z-index: 1;
	}
	.share {
		width: 15px;
	    padding: 12px 15px;
	    position: fixed;
	    top: 27px;
	    right: 0;
	    z-index: 1;
	}
	.banner{
		width: 100%;
		height: auto;
		padding-bottom: 77px;
		position: relative;
		.ban{
			display: block;
			width: 100%;
			min-height: 320px;
		}
		.word{
			width: 100%;
			position: absolute;
			left: 0;
			bottom: 0px;
			.box{
				width: calc(100% - 23px);
				margin-left: 12px;
				background: #fff;
				border-radius: 5px;
				text-align: center;
				padding-top: 16px;
				padding-bottom: 20px;
				.title{
					text-align: center;
					margin-bottom: 15px;
					img{
						width: 55px;
						display: inline-block;
						vertical-align: middle;
					}
					.middle{
						width: 153px;
						margin: 0 15px;
					}
					.right{
						transform:rotate(180deg);
						-ms-transform:rotate(180deg); 	/* IE 9 */
						-moz-transform:rotate(180deg); 	/* Firefox */
						-webkit-transform:rotate(180deg); /* Safari 和 Chrome */
						-o-transform:rotate(180deg); 
					}
					@media only screen and (min-width: 320px) and (max-width: 360px){
						img{
							width: 35px;
						}
						.middle{
							width: 120px;
						}
					}
				}
				.adv{
					color: #333;
					font-size: 15px;
					text-align: center;
					line-height: 21px;
					font-weight: bold;
				}
				@media only screen and (min-width: 320px) and (max-width: 360px){
					.adv{
						font-size: 13px;
					}
				}
			}
		}
		.corses{
			width: 72px;
			position: absolute;
			left: 0;
			bottom: 90px;
		}
	}
	.Profit{
		margin-top: 18px;
		.box{
			width: calc(100% - 52px);
			margin-left: 11px;
			background: #fff;
			border-radius: 5px;
			padding: 0 14px 0 16px;
			.title{
				text-align: center;
				img{
					width: 64%;
					margin-top: -3px;
				}
			}
			.profit1{
				padding-right: 140px;
				padding-top: 26px;
				position: relative;
				padding-bottom: 25px;
				img{
					width: 90px;
					position: absolute;
					top: 26px;
					right: 21px;
				}
				.tit{
					color: #fff;
					font-size: 18px;
					padding: 0 12px;
					background: #FCA755;
					border-radius: 17px;
					line-height: 35px;
					display: inline-block;
				}
				.desc{
					color: #333;
					font-size: 12px;
					margin-top: 12px;
					line-height: 21px;
					span{
						color: #FF201B;
					}
				}
			}
			.profit2{
				padding-left: 187px;
				position: relative;
				img{
					width: 104px;
					position: absolute;
					top: 5px;
					left: 14px;
				}
				.tit{
					color: #fff;
					font-size: 18px;
					padding: 0 12px;
					background: #FCA755;
					border-radius: 17px;
					line-height: 35px;
					display: inline-block;
				}
				.desc{
					color: #333;
					font-size: 12px;
					margin-top: 12px;
					line-height: 21px;
					span{
						color: #FF201B;
					}
				}
			}
			.profit3{
				padding: 12px 160px 14px 8px;
				.tit{
					margin-top: 3px;
				}
				img{
					width: 83px;
					top: 12px;
					right: 36px;
				}
			}
			.profit4{
				padding-left: 160px;
				padding-bottom: 11px;
				img{
					width: 83px;
					position: absolute;
					top: 0px;
					left: 24px;
				}
			}
			.profit5{
				padding: 0 117px 27px 10px;
				.tit{
					margin-top: 3px;
				}
				img{
					width: 74px;
					top: 0;
					right: 12px;
				}
			}
			@media only screen and (min-width: 320px) and (max-width: 360px){
				.profit1 {
				    padding-right: 85px;
				    padding-top: 26px;
				    position: relative;
				    padding-bottom: 25px;
				    img {
					    width: 82px;
					    position: absolute;
					    top: 30px;
					    right: 0;
					}
					.tit{
						font-size: 15px;
						line-height: 32px;
					}
				}
				.profit2 {
				    padding-left: 132px;
				    img {
					    width: 97px;
					    left: 0px;
					}
					.tit{
						font-size: 15px;
						line-height: 32px;
					}
				}
				.profit3 {
				    img{
						width: 76px;
					}
				}
				.profit4 {
					padding-left: 110px;
				    img{
						width: 77px;
					}
				}
				.profit5 {
				    img{
						width: 65px;
					}
				}
			}
		}
	}
	.advantage{
		padding: 21px 11px 0;
		.box{
			background: #fff;
			border-radius: 5px;
			padding-top: 20px;
			padding: 20px 38px 30px;
			.title{
				text-align: center;
				margin-bottom: 15px;
				img{
					width: 28px;
					display: inline-block;
					vertical-align: middle;
				}
				.middle{
					width: 94px;
					margin: 0 11px;
				}
			}
			.super{
				padding-top: 15px;
				.tit{
					position: relative;
					img{
						width: 17px;
						float: left;
						margin-top: 3px;
						vertical-align: middle;
					}
					.border{
						width: 121px;
						height: 8px;
						display: inline-block;
						margin-left: 10px;
						margin-top: 8px;
						vertical-align: middle;
						background: linear-gradient(to right,#E73733,#ffffff);
					}
					.name{
						color: #333;
						font-size: 17px;
						font-weight: bold;
						position: absolute;
						bottom: 0;
						left: 32px;
						line-height: 25px;
					}
				}
				.con{
					color: #333;
					font-size: 12px;
					line-height: 24px;
					margin-top: 5px;
				}
			}
			.super2 {
				img{
					width: 19px;
				}
			}
			.super4 {
				img{
					width: 18px;
				}
			}
			.super5 {
				img{
					width: 19px;
				}
			}
			.super6 {
				img{
					width: 16px;
				}
			}
		}
	}
	.require{
		padding: 0 7px;
		.title{
			margin-bottom: 16px;
			margin-top: 20px;
			text-align: center;
			img{
				width: 28px;
				display: inline-block;
				vertical-align: middle;
			}
			.middle{
				width: 95px;
				margin: 0 11px;
			}
		}
		.req{
			width: calc(50% - 15px);
			float: left;
			padding: 0 5px 10px;
			.box{
				width: 100%;
				background: #fff;
				border-radius: 5px;
				.con{
					/*width: 100%;*/
					padding: 15px 12px 20px;
					background: url(../../assets/advDetail/market/money.png) no-repeat right bottom;
					.top{
						color: #333;
						font-size: 18px;
						font-weight: bold;
						line-height: 47px;
					}
					@media only screen and (min-width: 320px) and (max-width: 360px){
						.top{
							font-size: 16px;
							line-height: 38px;
						}
					}
					.middle{
						color: #333;
						font-size: 12px;
						line-height: 22px;
						span{
							color: #EE3A36;
							font-size: 17px;
						}
					}
					.bottom{
						color: #333;
						font-size: 12px;
						line-height: 22px;
					}
				}
			}
		}
		.clear{
			clear: both;
		}
	}
	.contract{
		padding: 0 12px;
		margin-top: 16px;
		padding-bottom: 76px;
		.box{
			background: rgba(255,255,255,.15);
			border-radius: 5px;
			padding: 20px 20px 30px;
		}
		.title{
			text-align: center;
			margin-bottom: 10px;
			img{
				width: 140px;
				display: inline-block;
			}
		}
		.con{
			color: #FED8B9;
			font-size: 12px;
			line-height: 22px;
		}
		.tit{
			text-align: center;
			margin-top: 25px;
			margin-bottom: 12px;
			img{
				width: 140px;
				display: inline-block;
			}
		}
		.tip{
			text-align: center;
			color: #fff;
			font-size: 12px;
			line-height: 28px;
		}
		.phone{
			text-align: center;
			color: #fff;
			font-size: 18px;
			line-height: 30px;
			margin-top: -3px;
			font-weight: bold;
		}
		@media only screen and (min-width: 320px) and (max-width: 360px){
			.phone{
				font-size: 16px;
			}
			.tit {
			    text-align: center;
			    margin-top: 16px;
			    margin-bottom: 4px;
			    img{
					width: 125px;
				}
			}
			.box{
				padding: 15px 15px 20px;
			}
		}
	}
	.footer{
		background: #C11814;
		padding: 17px 12px 10px;
		height: 76px;
		width: 100%;
		position: fixed;
		left: 0;
		bottom: 0;
		z-index: 999;
		.btn{
			background: #FEEAC3;
			font-size: 18px;
			color: #C11814;
			font-weight: bold;
			height: 49px;
			line-height: 49px;
			width: 100%;
			text-align: center;
			display: inline-block;
			border-radius: 25px;
		}
	}
	@media only screen and (min-width: 320px) and (max-width: 360px){
		.footer{
			padding: 12px 12px 7px;
			height: 61px;
			.btn{
				font-size: 16px;
				height: 42px;
    			line-height: 42px;
			}
		}
	}
}
.isiOSX {
	.van-nav-bar {
		padding-top: 44px;
	}
	.reback {
		top: 47px;
	}
	.share {
		top: 47px;
	}
}


</style>
